<template>
  <img v-lazy="_src" class="default-image" />
  <!-- <img :src="src" class="default-image" @error="onError" /> -->
</template>

<script>
export default {
  props: ['src', 'defaultSrc'],
  computed: {
    _src() {
      if (this.defaultSrc) {
        return {
          src: this.src,
          error: this.defaultSrc
        };
      }
      return this.src;
    }
  }
};
</script>

<style>
img[lazy='loading'] {
  background: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/components/lazy-image/index.vue